module.exports = __webpack_public_path__ + "img/engravingSymbol@2x.f9e2737.webp";